// extracted by mini-css-extract-plugin
export default {"totalBetCell":"eU_eV","totalBetCell_close":"eU_eW","balanceCell_close":"eU_eJ"};